import { render, staticRenderFns } from "./tobesigned.vue?vue&type=template&id=1606ed98&scoped=true&"
import script from "./tobesigned.vue?vue&type=script&lang=js&"
export * from "./tobesigned.vue?vue&type=script&lang=js&"
import style0 from "./tobesigned.vue?vue&type=style&index=0&id=1606ed98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1606ed98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jasonliuhan/Documents/project/jcfy-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1606ed98')) {
      api.createRecord('1606ed98', component.options)
    } else {
      api.reload('1606ed98', component.options)
    }
    module.hot.accept("./tobesigned.vue?vue&type=template&id=1606ed98&scoped=true&", function () {
      api.rerender('1606ed98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/container/myinfo/tobesigned.vue"
export default component.exports